import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import SettingsLayout from '../../layouts/SettingsLayout'
import { AccountAndFacturationsPage } from '../../pages/features/settings/account/AccountAndFacturationsPage'
import { PreferencesPage } from '../../pages/features/settings/preferences/PreferencesPage'
import { DatabasePage } from '../../pages/features/settings/database/DataBaePage'
import EntrepriseModulesPage from '../../pages/features/settings/entreprise-modules/EntrepriseModulesPage'


export default function SettingNav() {
    return (
        <SettingsLayout>
            <Routes>
                <Route path='/' element={<Navigate to='account' replace />} />

                <Route path="/account" element={<AccountAndFacturationsPage />} />
                <Route path="/preferences" element={<PreferencesPage/>} />
                <Route path="/database" element={<DatabasePage/>} />
                <Route path="/entreprise-module" element={<EntrepriseModulesPage/>} />

            </Routes>
        </SettingsLayout>
    )
}
